import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'

import RanRoomView from './ran-room-view'
import ResetPopin from './reset-popin'
import { resetRanRoom } from '@portal/kit/pkg/services'

class RanRoomContainer extends Component {
  state = {
    showDevices: false,
    showResetPopin: false,
    updatedRoom: null,
    popinError: null,
    isLoading: false,
    psk: this.props.data.psk
  }


  toggleDevices = () => this.setState({ showDevices: !this.state.showDevices })

  resetRoom = () => {
    this.setState({ isLoading: true })

    resetRanRoom(this.props.data.id)
      .then(response => this.setState({ updatedRoom: response.data, isLoading: false, psk: response.data.psk }))
      .catch(e => this.setState({ popinError: this.props.t('form.error'), isLoading: false }))
  }

  showReset = () => this.setState({ showResetPopin: true })
  cancelReset = () => this.setState({ showResetPopin: false, popinError: null })

  render() {
    return (
      <Fragment>
        <RanRoomView
          data={{...this.props.data, psk: this.state.psk}}
          psk={this.state.psk}
          showDevices={this.state.showDevices}
          toggleDevices={this.toggleDevices}
          resetRoom={this.showReset}
        />
        <ResetPopin
          isOpened={this.state.showResetPopin}
          isLoading={this.state.isLoading}
          popinError={this.state.popinError}
          data={{...this.props.data, psk: this.state.psk}}
          updatedRoom={this.state.updatedRoom}
          resetRoom={this.resetRoom}
          cancelReset={this.cancelReset}
        />
      </Fragment>
    )
  }

}

RanRoomContainer.propTypes = {
  data: PropTypes.object.isRequired,
}

export default compose(
  withTranslation(),
)(RanRoomContainer)
